import React from 'react';
import { MessageDescriptor } from '@lingui/core';
import { t } from '@lingui/macro';
import { Trans } from '@lingui/react';
import styled from 'styled-components';

import { Box, Flex, Heading, Image as KibbleImage, Paragraph } from '@rover/kibble/components';
import type { ThemeHeadingSizes } from '@rover/kibble/styles';
import { DSTokenMap, MQ } from '@rover/kibble/styles';
import { Image } from '@rover/react-lib/src/components';
import { useI18n } from '@rover/rsdk/src/modules/I18n';
import { isTranslatable } from '@rover/utilities/i18n';

export type Props = {
  headerText?: React.ReactNode | MessageDescriptor;
  headerTextSize?: ThemeHeadingSizes;
  subHeadlineText?: React.ReactNode | MessageDescriptor;
  image: string;
  fullWidthImage?: boolean;
  coverFitImage?: boolean;
  subImageText?: React.ReactNode | MessageDescriptor;
};

const CoverImgBox = styled(Box)`
  ${MQ.XS.toString()} {
    margin-top: ${DSTokenMap.SPACE_0X};
    width: 100%;
  }
`;

const StyledKibbleImage = styled(KibbleImage)`
  ${MQ.XS.toString()} {
    margin-top: ${DSTokenMap.SPACE_0X};
    width: 100%;
  }
`;

const DoodleHeader = (props: Props): JSX.Element => {
  const {
    headerText,
    headerTextSize,
    subHeadlineText,
    image,
    fullWidthImage,
    coverFitImage,
    subImageText,
  } = props;

  const { i18n } = useI18n();

  return (
    <Flex flexDirection="column" alignItems="center">
      {coverFitImage ? (
        <CoverImgBox pb="4x" width={fullWidthImage ? '100%' : ''}>
          {image && (
            <StyledKibbleImage
              width="560px"
              height="280px"
              resizeMethod="cover"
              description={i18n._(t`graphic doodle or pet`)}
              src={image}
            />
          )}
        </CoverImgBox>
      ) : (
        <Box pb="4x" width={fullWidthImage ? '100%' : ''}>
          {image && <Image alt="" src={image} width="100%" />}
        </Box>
      )}
      <Box pb="4x" width="100%">
        {subImageText && (
          <Paragraph
            textAlign="left"
            size="100"
            pt={['0x', '2x']}
            pb={['2x', '4x']}
            mb="0x"
            textColor="tertiary"
          >
            {isTranslatable(subImageText) ? <Trans id={subImageText} /> : subImageText}
          </Paragraph>
        )}
        {headerText && (
          <Heading size={headerTextSize} mb={['2x', '4x']}>
            {isTranslatable(headerText) ? <Trans id={headerText} /> : headerText}
          </Heading>
        )}
        {subHeadlineText && (
          <Paragraph size="200" mb="0x">
            {isTranslatable(subHeadlineText) ? <Trans id={subHeadlineText} /> : subHeadlineText}
          </Paragraph>
        )}
      </Box>
    </Flex>
  );
};

DoodleHeader.defaultProps = {
  headerTextSize: '300',
};

export default DoodleHeader;
